import { View } from '@amzn/stencil-react-components/layout';
import styled from '@emotion/styled';
import React from 'react';
import { useSelector } from 'react-redux';
import { notificationSelector } from '../../selectors/selectors';
import ToastNotificationBody from './ToastNotificationBody';

const ToastNotification = () => {
  const notifications = useSelector(notificationSelector);

  const NotificationContainer = styled(View)({
    boxSizing: 'border-box',
    position: 'fixed',
    zIndex: 999999,
    width: '78%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  });

  return (
    <>
      <NotificationContainer>
        {notifications?.map((toast, i) => <ToastNotificationBody {...toast} />)}
      </NotificationContainer>
    </>
  );
};

export default ToastNotification;
